import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewChecked
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { BaseManagement } from 'src/app/core/services/base-management';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';

import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { TransactionRequestService } from 'src/app/pages/transaction-admin/services/transaction-request.service';

@Component({
  selector: 'div.component-loader',
  templateUrl: './component-loader.component.html',
  styleUrls: ['./component-loader.component.scss']
})
export class ComponentLoaderComponent extends BaseManagement implements OnInit, AfterViewChecked {
  
  minimize: boolean = false;
  moduleLoadError: boolean = false;

  constructor(
    public dynamicFormService: DynamicFormService,
    public transactionService: TransactionService,
    public translate: TranslateService,
    public multiLanguageService: MultiLanguageService,
    public transactionRequestService: TransactionRequestService,
    private cdr: ChangeDetectorRef
    ) {
    super();
    
    this.dynamicFormService.formCommunicator.subscribe((data) => {
      if(data=="stop-saving"){
      this.stopSaving();
      }
    });      
  }

  ngOnInit() {

    this.dynamicFormService.revisionMode = false;
    this.moduleLoadError = false;

    // Verificar si hay un formName válido
    if (!this.dynamicFormService.formName) {
      console.error('ComponentLoader: No formName provided');
      this.moduleLoadError = true;
      return;
    }

    if(this.dynamicFormService.requirement.IsFlagedForVerification && 
       this.transactionService.itemToEdit.CreatedByCurrentUser){
        
        this.dynamicFormService.revisionMode = true;
    }
    
    // Detectar errores de carga después de un timeout
    setTimeout(() => {
      if (this.dynamicFormService.isLoadingForm === true) {
        console.error('ComponentLoader: Module loading timeout or error detected');
        this.moduleLoadError = true;
        this.dynamicFormService.isLoadingForm = false;
        this.cdr.detectChanges();
      }
    }, 10000); // 10 segundos timeout
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  minimizeRevisionAlert(action){
    this.minimize = false;
    if(action == true){
      this.minimize = true
    }
  }

  trySubmitForReview(){
    if(this.isSaving()) return;

    this.startSaving("submit-for-review")

    this.dynamicFormService.formCommunicator
    .next("save-data")
  }

  retryLoadModule() {
    this.moduleLoadError = false;
    this.dynamicFormService.isLoadingForm = true;
    
    // Reiniciar el timeout para detectar errores
    setTimeout(() => {
      if (this.dynamicFormService.isLoadingForm === true) {
        console.error('ComponentLoader: Module loading timeout or error detected on retry');
        this.moduleLoadError = true;
        this.dynamicFormService.isLoadingForm = false;
        this.cdr.detectChanges();
      }
    }, 10000); // 10 segundos timeout
    
    this.cdr.detectChanges();
  }

  close(){
  	this.dynamicFormService.formName = "";
  	this.dynamicFormService.formLoaderIsVisible = false;  	
  }
}
